import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "./userSlice"; // Adjust path as necessary

const rootReducer = combineReducers({
  user: userReducer,

  // add other slice reducers here
});

export default rootReducer;
